module.exports = __webpack_public_path__ + "img/bannerbg.eca56992.png";